import { QueryProvider } from 'aem-libs-react-components/src/components/utility/query-provider/QueryProvider'

import { BurinkaConsolidationContainer } from './containers/BurinkaConsolidationContainer'

export const App = () => {
  return (
    <QueryProvider>
      <BurinkaConsolidationContainer />
    </QueryProvider>
  )
}
